// reportSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  loading: false,

  // Reports
  monthlySalesReport: [],
  dailySalesReport: [],
  returnCustomerReport: [],
  // Add more reports here later
};

const slice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
    },
    hasError(state, action) {
      state.error = { message: action.payload, time: moment().toISOString() };
      state.loading = false;
    },

    // Set data for reports
    setMonthlySalesReport(state, action) {
      state.monthlySalesReport = action.payload;
      state.loading = false;
    },
    setDailySalesReport(state, action) {
      state.dailySalesReport = action.payload;
      state.loading = false;
    },
    setReturnCustomerReport(state, action) {
      state.returnCustomerReport = action.payload;
      state.loading = false;
    },
  },
});

export default slice.reducer;

// ----------------------------------------------------------------------
// Async actions

// 1. Monthly Sales Report
export function getMonthlySalesReport(locationId, fromDate, toDate) {
  return async () => {
    try {
      dispatch(slice.actions.startLoading());
      const response = await get(`monthlySalesReport?locationId=${locationId}&fromDate=${fromDate}&toDate=${toDate}`);
      if (response.status) {
        dispatch(slice.actions.setMonthlySalesReport(response.data));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
    }
  };
}

// // 2. Daily Sales Report
// export function fetchDailySalesReport(locationId, date) {
//   return async () => {
//     try {
//       dispatch(slice.actions.startLoading());
//       const response = await get(`dailySalesReport?locationId=${locationId}&date=${date}`);
//       if (response.status) {
//         dispatch(slice.actions.setDailySalesReport(response.data));
//       } else {
//         dispatch(slice.actions.hasError(response.message));
//       }
//     } catch (error) {
//       dispatch(slice.actions.hasError(error.toString()));
//     }
//   };
// }

// // 3. Return Customer Report
// export function fetchReturnCustomerReport(locationId, fromDate, toDate) {
//   return async () => {
//     try {
//       dispatch(slice.actions.startLoading());
//       const response = await get(`posReturnCustomerReport?locationId=${locationId}&fromDate=${fromDate}&toDate=${toDate}`);
//       if (response.status) {
//         dispatch(slice.actions.setReturnCustomerReport(response.data));
//       } else {
//         dispatch(slice.actions.hasError(response.message));
//       }
//     } catch (error) {
//       dispatch(slice.actions.hasError(error.toString()));
//     }
//   };
// }
